import * as React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as Api from 'src/api';
import TagsForm from 'src/components/Tags/form';
import { patchTags } from '../../actions/index';

class Container extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      tagId: this.props.match.params.id,
      isLoading: true,
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  public async onSubmit(body: any): Promise<void> {
    const { data } = await Api.updateTag(this.state.tagId, body);

    toast.success('El registro fue actualizado con éxito');
    this.props.patchTags(data);

    return this.props.history.push('/tags');
  }

  public render() {
    if (this.state.isLoading) {
      return null;
    }

    return (
      <TagsForm
        onSubmit={this.onSubmit}
        tag={this.state.tag}
      />
    );
  }

  public async componentDidMount() {
    const { data } = await Api.getTag(this.state.tagId);

    this.setState({
      tag: data,
      isLoading: false,
    });
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    patchTags: (b: any) => dispatch(patchTags(b)),
  }
};

export default connect(null, mapDispatchToProps)(Container);



// WEBPACK FOOTER //
// ./src/containers/Tags/edit.tsx